import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CourseDetailsComponent } from './courses/course-details.component';
import { EventDetailsComponent } from './events/details/event-details.component';
import { MyLiveEventsComponent } from './my-account/my-live-events/my-live-events.component';
import { OrganizationCmsWrapperComponentComponent } from './organization/cms/organization-cms-wrapper-component.component';
import { OrganizationLayoutComponent } from './organization/cms/organization-layout.component';
import { OrganizationPageComponent } from './organization/cms/page/organization-page.component';
import { SharedAccountConferenceModule } from './shared-account-conference.module';
import { SharedCMSModule } from './shared-cms-module';
import { CompanyAdminGuard } from './_guards/company-admin.gaurd';
import { IsAuthenticatedGuard } from './_guards/isAuthenticated.gaurd';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';

@NgModule({
  declarations: [
    OrganizationCmsWrapperComponentComponent,
    OrganizationLayoutComponent,
    OrganizationPageComponent
  ],
  imports: [
    ApplicationPipesModule.forRoot(),
    SharedAccountConferenceModule,
    SharedCMSModule,
    RouterModule.forChild([

      { path: '', component: OrganizationLayoutComponent, children:[
        { path: '', redirectTo: 'home', pathMatch: 'full' },
        { path: 'events/:id', component: EventDetailsComponent, data: { isConference: true}},
        { path: 'courses/:id', component: CourseDetailsComponent, data: { isConference: true}},
        { path: 'my-events', component: MyLiveEventsComponent, canActivate: [IsAuthenticatedGuard], data:{title:'My Live events'} },
        { path: ':organizationId/admin', data: { preload: true, loadAfterSeconds: 5 }, component: OrganizationCmsWrapperComponentComponent, canActivate: [CompanyAdminGuard], loadChildren: () => import('./organization-admin.module').then((m) => m.OrganizationAdminModule) },
        { path: 'conferences/:conferenceSlug', data: { preload: true }, component: OrganizationCmsWrapperComponentComponent, loadChildren: () => import('./conference-cms.module').then((m) => m.ConferenceCMSModule) },
        { path: ':page', component: OrganizationPageComponent },

      ]},


    ]),
  ],
})
export class OrganizationCMSModule {}
